import { Culture, cultureLabels, cultures } from "../../context/VolunteersHighlightContext/constants";
import { VolunteersExperienceRules } from "../../context/VolunteersExperienceContext/constants";

export const GENERAL_SECTION_KEY = "general";

export const getDetailSectionKey = (culture: Culture) => `detail-${culture}`;

export const VolunteersExperienceFormKeys = [GENERAL_SECTION_KEY, ...cultures.map(getDetailSectionKey)];

export const VolunteersExperienceSectionLabels = {
	GENERAL: "Genel Bilgiler",
	getDetail: (culture: Culture) => `Gönüllü Deneyimi Detayı - ${cultureLabels[culture]}`,
};

export const VolunteersExperienceGeneralTexts = {
	isActive: {
		label: "Aktiflik Durumu",
		helperText: "Aktif olmayan gönüllü deneyimleri sayfada gözükmez.",
	},
	displayOrder: {
		label: "Sıra Numarası",
		placeholder: "1",
	},
	name: {
		label: "Ad",
		placeholder: "Gönüllünün adı",
	},
	surname: {
		label: "Soyad",
		placeholder: "Gönüllünün soyadı",
	},
	picture: {
		label: "Fotoğraf",
	},
};

type DetailFieldTexts = {
	title: { label: string; placeholder: string };
	company: { label: string; placeholder: string };
	description: { label: string; placeholder: string };
};

export const VolunteersExperienceDetailTexts: Record<Culture, DetailFieldTexts> = {
	"tr-TR": {
		title: {
			label: "Unvan",
			placeholder: "Gönüllü Lideri",
		},
		company: {
			label: "Şirket",
			placeholder: "Şirket adı",
		},
		description: {
			label: "Deneyim",
			placeholder: "Gönüllünün projedeki deneyimini anlatan metin",
		},
	},
	"en-US": {
		title: {
			label: "Title",
			placeholder: "Volunteer Leader",
		},
		company: {
			label: "Company",
			placeholder: "Company name",
		},
		description: {
			label: "Experience",
			placeholder: "The volunteer's experience in the project",
		},
	},
};

export const VolunteersExperiencePictureUpload: {
	maxFileSize: string;
	extensions: ("jpeg" | "jpg" | "png" | "gif")[];
} = {
	maxFileSize: String(VolunteersExperienceRules.pictureMaxFileSize),
	extensions: ["jpeg", "jpg", "png", "gif"],
};
